import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function ImportExportQuantity({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let importQty = foodAnswers.answerKeyValues['u_s_imports_quantity'];
	let importQtyYear = foodAnswers.answerKeyValues['u_s_imports_quantity_year'];
	let importQtySourceRef = foodAnswers.answerKeyValues['u_s_imports_quantity_sources'];
	let importQtyNotes = foodAnswers.answerKeyValues['u_s_imports_quantity_notes'];
	let importExportUnit = foodAnswers.answerKeyValues['u_s_imports_quantity_unit'] || "Metric Tons";
	
	let exportQty = foodAnswers.answerKeyValues['u_s_exports_quantity'];
	//let exportValueYear = foodAnswers.answerKeyValues['u_s_exports_value_year'];
	//let exportValueSourceRef = foodAnswers.answerKeyValues['u_s_exports_value_sources'];
	let exportQtyNotes = foodAnswers.answerKeyValues['u_s_exports_quantity_notes'];
	
	let array = [];
	let importDataSeries = [];
	let xCategories = [];
	if (importQty) {
		try {
			array = JSON.parse(importQty);
		} catch (err) {
			console.log("ImportExportQuantity :importQty: " + err);
		}
		importDataSeries = array.map(function(obj) {
			if (obj && obj["weight_kiloliters_"]) {
				return [parseFloat(obj["weight_kiloliters_"].replace(/,/g, ''))];
			}
		});
		xCategories = array.map(function(obj) {
			if (obj && obj["year"]) {
				return [parseInt(obj["year"])];
			}
		});
	}
	
	let exportDataSeries = [];
	if (exportQty) {
		try {
			array = JSON.parse(exportQty);
		} catch (err) {
			console.log("ImportExportQuantity :exportQty: " + err);
		}
		exportDataSeries = array.map(function(obj) {
			if (obj && obj["weight_kiloliters_"]) {
				return [parseFloat(obj["weight_kiloliters_"].replace(/,/g, ''))];
			}
		});
	}
	
	return(
			<div>
				<h2 style={{textAlign: "center"}}>
					US Imports and Exports by Quantity&nbsp;
					{importQtyYear ? 
					<small>&nbsp;({importQtyYear})</small>
					: ""}
					{ importQtySourceRef && importQtySourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+importQtySourceRef}>{importQtySourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					chart: {
				        type: 'column'
				    },
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					title: {
						text: ''
			  		},
				  	yAxis: {
			          title:  {
						text: importExportUnit
				  		}
			        },
			        xAxis: {
			          title:  {
						text: ''
				  		},
				  	  categories: xCategories	
			        },
					series: [
							{
							name: "US Imports",
							data: importDataSeries
							},
							{
							name: "US Exports",
							data: exportDataSeries
							}
						]
				}}
				/>
				<p className="notes-info" style={{marginTop: "auto"}}>
				{(importQtyNotes ) || (exportQtyNotes  ) ? 
				<em>
				{(importQtyNotes ) ? 
					importQtyNotes
					: ""}
				{importQtyNotes ? <br /> :""}
				{(exportQtyNotes  ) ? 
					exportQtyNotes
				: ""}
				</em>
				:""}
				</p>
			</div>
		)
}
export default ImportExportQuantity;